module.exports = __webpack_public_path__ + "images/logo-notext.337997ab72ce0af2ddc9a152e213269e.svg";